var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTik(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 141.247 160.993",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_41538",
    "data-name": "Path 41538",
    d: "M4424.56-446.4c.578,20.609,16.344,39.338,40.8,40.394v25.875c-14.894.112-28.135-4.7-40.589-13.7,0,1.48,0,2.44,0,3.4.066,18.114.211,36.228.18,54.341-.041,23.837-15.2,43.228-38.241,49.14-27.172,6.971-55.512-10.334-61.426-37.509a49.625,49.625,0,0,1,40.063-59.739c5.35-.93,10.894-.748,16.581-1.093v26.851a80.724,80.724,0,0,0-9.433-.437c-12.394.813-21.947,11.505-21.768,24.11a23.961,23.961,0,0,0,23.08,23.274,23.8,23.8,0,0,0,24.418-21.176c.17-1.735.235-3.486.236-5.23q.042-52.411.055-104.822V-446.4Z",
    transform: "translate(-4324.114 446.402)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTik);
export default __webpack_public_path__ + "static/media/tik.836770ce5152b8d37b916dc2bfcdfbb0.svg";
export { ForwardRef as ReactComponent };